import React, { Fragment } from 'react';
import Container from '../../../../../../components/container';
import { H3, Cols } from '../../../../components';

const ITEMS = [
  {
    imageSrc: process.env.NEXT_PUBLIC_PUBLIC_URL + "/img/cours/private/operation-item-1.png",
    title: "Je m’inscris",
    titleColor: "red",
    description: <Fragment>
      Je valide ma formation.<br/>
      J’indique mes coordonnées.<br/>
      Je présente mes expériences.<br/>
      J’ajoute une photo.
    </Fragment>
  },

  {
    imageSrc: process.env.NEXT_PUBLIC_PUBLIC_URL + "/img/cours/private/operation-item-2.png",
    title: "Je réponds aux offres",
    titleColor: "blue",
    description: <Fragment>
      J’accepte ou non
      les propositions de cours.<br/>
      J’obtiens les coordonnées
      des élèves.<br/>
      Je les rencontre.
    </Fragment>
  },

  {
    imageSrc: process.env.NEXT_PUBLIC_PUBLIC_URL + "/img/cours/private/operation-item-3.png",
    title: "Je donne mes cours",
    titleColor: "red",
    description: <Fragment>
      J’aide mon élève.<br/>
      Je reporte le cours avec sa durée sur mon espace (en 1 minute).
    </Fragment>
  },

  {
    imageSrc: process.env.NEXT_PUBLIC_PUBLIC_URL + "/img/cours/private/operation-item-4.png",
    title: "Je suis payé",
    titleColor: "blue",
    description: <Fragment>
      Je suis payé sous 48h au prorata de la durée du cours.<br/>
      Un élève a progressé ;)
    </Fragment>
  }
].map(item => ({titleProps: {smMinHeight: 58}, ...item}));


const OperationsSection = props => {
  return (
    <Container {...props}>
      <H3>{props.title}</H3>

      <Cols items={ITEMS} />
    </Container>
  )
}

OperationsSection.defaultProps = {
  title: 'Touver un élève et job étudiant devient simple',
};

export default OperationsSection;